import { useMedia } from "hooks/useMedia";
import StatusColumn from "./status-column";

const TaskColumn = ({ title, notes, status }) => {
  const { isMobile } = useMedia();
  return (
    <div className="row">
      <div className="__container">
        <div className="task-title">{title}</div>
        <div className="task-notes">{notes}</div>
      </div>
      {isMobile && (
        <>
          <div className="flex-1" />
          <StatusColumn status={status} />
        </>
      )}
      <style>{`
          .__container {
            display: flex;
            flex-direction: column;
            min-width: 100px;
          }
          .column {
            display: flex;
            flex-direction: column;
            min-width: 175px;
          }
          .row {
            display: flex;
            flex-direction: row;
          }
          .flex-1 {
            flex: 1;
          }
          .task-title {
            color: #2d4e77;
            font-size: 0.95em;
            font-weight: bold;
          }
          .task-notes {
            margin-top: 1em;
            color: #555;
            font-size: 0.9em;
          }
        `}</style>
    </div>
  );
};

export default TaskColumn;
